<template>
  <el-dialog
    v-if="isShowDialog"
    title="已上架商品"
    center
    top="5vh"
    :visible.sync="isShowDialog"
    append-to-body
    width="90%"
    :before-close="beforeclose"
  >
    <el-form
      :inline="true"
      ref="searchform"
      :model="formData"
      class="demo-form-inline"
      size="medium"
    >
      <el-form-item label="商品ID" prop="productId">
        <el-input
          style="width: 200px"
          v-model="formData.productId"
          placeholder="请输入商品ID"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="商品名称" prop="keyword">
        <el-input
          style="width: 200px"
          v-model="formData.keyword"
          placeholder="请输入商品名称"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="选择分类" prop="categoryId">
        <CategorySelect
          :categoryId="formData.categoryId"
          :channelCode="formData.channelCode"
          :channelCodes="formData.channelCodes"
          @changeCascader="changeCascaderTwo"
        >
        </CategorySelect>
      </el-form-item>
      <span style="margin-left: 20px">
        <el-button type="primary" @click="search">查询</el-button>
        <el-button @click="resetForm('searchform')">重置</el-button>
      </span>
    </el-form>
    <div>
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%"
        @select="changeFun"
        @selection-change="handleSelectionChange"
        ref="multipleTable"
        row-key="productId"
      >
        <el-table-column
          type="selection"
          width="55"
          :selectable="selected"
          reserve-selection
          align="center"
        ></el-table-column>
        <el-table-column prop="productId" label="商品编号" align="center">
        </el-table-column>
        <el-table-column prop="productName" label="商品名称" align="center">
        </el-table-column>
        <el-table-column prop="specification" label="规格" align="center">
        </el-table-column>
        <el-table-column label="商品分类名称" align="center">
          <template slot-scope="scope">
            {{ scope.row.categoryName }}
            <span v-if="scope.row.secondaryCategoryName"
              >/{{ scope.row.secondaryCategoryName }}</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="cost" label="成本价(元)" align="center">
        </el-table-column>
        <el-table-column prop="minPrice" label="页面最低价(元)" align="center">
        </el-table-column>
        <el-table-column prop="stock" label="库存" align="center">
        </el-table-column>
        <el-table-column prop="status" label="状态" align="center">
          <template slot-scope="scope">
            <el-tag size="mini" type="" v-if="scope.row.status == 1"
              >已上架</el-tag
            >
            <el-tag size="mini" type="danger" v-if="scope.row.status == 2"
              >已下架</el-tag
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="coupon-clock-paging">
      <div>已选商品数量：{{ goods.length }}</div>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="formData.page"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="formData.pageSize"
        layout="total,sizes, prev, pager, next, jumper"
        :total="total"
        background
      ></el-pagination>
    </div>
    <el-row type="flex" justify="center" style="margin-top: 30px">
      <el-button @click="beforeclose">取消</el-button>
      <el-button type="primary" @click="saveData" :loading="saveLoading"
        >确定</el-button
      >
    </el-row>
  </el-dialog>
</template>

<script>
import { queryMallProductList } from "@/api/shop/couponManage";
import CategorySelect from "@/myviews/shoppMall/components/CategorySelect.vue"; //分类
import { getSpreadActivityProductList } from "@/api/shop/activitySet";
export default {
  props: ["isShowDialog", "SelectedProductList", "canMultipleChoice"],
  components: {
    CategorySelect
  },
  data() {
    return {
      saveLoading: false,
      formData: {
        status: 1, //商品状态(1:上架 2:下架)
        productId: "", //商品Id
        productIdList: "", //商品ID列表
        productName: "", //商品名称
        categoryId: "", //分类id
        keyword: "",
        channelCode: "", // 渠道编码（编辑的时候使用这个字段）
        channelCodes: ["SHOP"], // 渠道编辑集合（新增的时候使用这个字段）
        page: 1, //当前页
        pageSize: 10 //页面数量
      },
      loading: false,
      channelSelects: [], // 渠道数据

      tableData: [], //表单数据
      total: 0, //总条数
      selectionData: [], //选中数据
      selectedIds: []
    };
  },
  watch: {
    isShowDialog: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.getData();
        }
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    goods() {
      const parmas = this.selectionData.concat(this.SelectedProductList || []);
      const uniqueArray = this.uniqueById(parmas, "productId");
      return uniqueArray;
    }
  },
  methods: {
    uniqueById(array, property) {
      return array.filter(
        (obj, index, self) =>
          index === self.findIndex(o => o[property] === obj[property])
      );
    },
    getData() {
      let data = {
        ...this.formData
      };
      this.loading = true;
      queryMallProductList(data).then(res => {
        this.loading = false;
        if (res.code == 200) {
          this.total = res.data.count;
          let arry = res.data.rows;
          this.tableData = arry;
          let arryAll = this.SelectedProductList
            ? this.SelectedProductList.map(v => v.productId)
            : [];
          let selectedIds = this.selectedIds;
          for (let i in arry) {
            if (
              arryAll.indexOf(arry[i].productId) >= 0 &&
              selectedIds.indexOf(arry[i].productId) == -1
            ) {
              this.$refs.multipleTable.toggleRowSelection(arry[i]);
              this.selectedIds.push(arry[i].productId);
            }
          }
        }
      });
    },
    search() {
      this.formData.page = 1;
      this.getData();
    },
    selected(row, index) {
      if (this.selectedIds.indexOf(row.productId) >= 0) {
        return false;
      } else {
        return true;
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.getData();
    },

    //修改每页数量
    handleSizeChange(val) {
      this.formData.pageSize = val;
      this.formData.page = 1;
      this.getData();
    },
    handleSelectionChange(val) {
      this.selectionData = val;
    },

    handleGoodsData(params) {
      // 这里直接参考小程序的逻辑，因不支持 a?.b?.c 这种语法, 改用三目
      const activityBgStyle = params
        ? params.activityInfo
          ? params.activityInfo.activityBgStyle
            ? JSON.parse(params.activityInfo.activityBgStyle)
            : undefined
          : undefined
        : null;

      const showStart = params
        ? params.activityInfo
          ? params.activityInfo.showStartPositions
            ? params.activityInfo.showStartPositions.includes("4")
            : undefined
          : undefined
        : undefined;

      const showEnd = params
        ? params.activityInfo
          ? params.activityInfo.showEndPositions
            ? params.activityInfo.showEndPositions.includes("4")
            : undefined
          : undefined
        : undefined;

      const showJiaoBiao = params
        ? params.activityInfo
          ? params.activityInfo.styleShowPositions
            ? params.activityInfo.styleShowPositions.includes("2")
            : undefined
          : undefined
        : undefined;

      return {
        ...params,
        activityInfo: {
          ...params.activityInfo,
          activityBgStyle,
          // 4 就是搜索 活动页  时间 展示开始 和 结束
          showStart,
          showEnd,
          // 2 就是 搜索活动页面 角标 是否展示
          showJiaoBiao
        }
      };
    },
    async saveData() {
      const { canMultipleChoice, goods, selectionData } = this;
      if (canMultipleChoice) {
        if (goods.length) {
          try {
            const ids = goods.map(item => item.productId);
            if(ids.length > 100) return this.$message.error("最多添加100个商品")
            this.saveLoading = true;
            const params = await this.getSpreadActivityProductList(ids);
            this.saveLoading = false;
            const handleParams = params.map(item => {
              return this.handleGoodsData(item);
            });
            this.$emit("selectProductList", handleParams);
            this.beforeclose();
          } catch (error) {
            this.saveLoading = false;
            this.$message.warning(error);
          }
        } else {
          this.$message.warning("请选择商品");
        }
        return;
      }

      if (selectionData.length == 1 && !canMultipleChoice) {
        this.$emit("selectProductList", selectionData[0].productId);
        this.resetForm();
      } else {
        this.$message.warning("只能选择1项商品");
      }
    },
    async getSpreadActivityProductList(ids) {
      try {
        const { data, code, mes } = await getSpreadActivityProductList(ids);
        if (code === 200) {
          return Promise.resolve(data);
        } else {
          return Promise.reject(mes);
        }
      } catch (_) {
        return Promise.reject("请求异常");
      }
    },
    resetForm() {
      this.formData.status = 1; //商品状态(1:上架 2:下架)
      this.formData.productId = ""; //商品Id
      this.formData.productIdList = ""; //商品ID列表
      this.formData.productName = ""; //商品名称
      this.formData.categoryId = ""; //分类id
      this.formData.page = 1; //当前页
      this.formData.pageSize = 10; //页面数量
      this.selectionData = []; //选中数据
      this.selectedIds = [];
    },
    //切换页面
    handleCurrentChange(val) {
      this.formData.page = val;
      this.getData();
    },
    beforeclose() {
      this.resetForm();
      this.$emit("closeShowDialog", false);
    },
    changeCascaderTwo(value) {
      // 商品分类选择
      // console.log(value, 'value')
      this.formData.categoryId = value;
    },
    changeFun(selection, row) {
      if (selection.length > 1 && !this.canMultipleChoice) {
        const del_row = selection.shift();
        this.$refs.multipleTable.toggleRowSelection(del_row, false);
      }
      this.checkList = selection[0];
    }
  }
};
</script>

<style scoped lang="less">
.coupon-clock-paging {
  width: 100%;
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/components/SelectProductDialog.vue